import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import appStoreFactory from '../../app/store/factory';
import AppStoreReadyStateEnum from '../../app/store/ready-state.enum';
import { AccountAuthApiServiceFactory } from '../api/service-factory';
const registerService = AccountAuthApiServiceFactory();
@Module({
  dynamic: true,
  name: 'hermes-otl',
  store: appStoreFactory(),
  namespaced: true,
})
class HermesOtlModule extends VuexModule {
  public loadingState: AppStoreReadyStateEnum = AppStoreReadyStateEnum.pending;
  public data: any | null = null;
  public error: Error | null = null;

  @Mutation
  private SET_VALUES(data: any): void {
    this.data = data;
  }

  @Mutation
  private VALIDATE(): void {
    this.loadingState = AppStoreReadyStateEnum.loading;
  }

  @Mutation
  private VALIDATE_SUCCESS(): void {
    this.loadingState = AppStoreReadyStateEnum.loaded;
  }

  @Mutation
  private VALIDATE_ERROR(): void {
    this.loadingState = AppStoreReadyStateEnum.error;
  }

  @Action({ rawError: true })
  public setValues(data: any): void {
    this.SET_VALUES(data);
  }

  @Action
  public async getHermesOtl(): Promise<{ token: string }> {
    try {
      this.VALIDATE();
      const response = await registerService.getHermesOtl();
      this.VALIDATE_SUCCESS();
      return response;
    } catch (error: any) {
      this.VALIDATE_ERROR();
      return error.response.data;
    }
  }
}

export const HermesOtlStoreModule = getModule(HermesOtlModule);
